import React from "react";
import { graphql } from "gatsby";
import Image from "../base/image";
import TopBarIcons from "../icons/topBarIcons";
import Button from "../base/button";

const IconAndImageCard = (props) => {
  const { cardImage, title, copy, buttonText, buttonType, link, objectFit } = props;
  const heading = title ? <h3 className={`${copy ? "h4" : "h4 no-margin"}`}>{title}</h3> : "";
  const bodyCopy = copy ? <p className={`${(buttonText && link) || title ? "" : "no-margin"}`}>{copy}</p> : "";
  const buttonIcon = buttonType === "external" || buttonType === "download" ? <TopBarIcons name={buttonType} /> : "";
  const button =
    buttonText && link ? (
      <Button href={link} type={`btn-${buttonType ? buttonType : "tertiary-small"}`} text={buttonText}>
        {" "}
        {buttonIcon}{" "}
      </Button>
    ) : (
      ""
    );
  const image = cardImage ? (
    <div className={`card--image`}>
      <Image imageData={cardImage} objectFit={objectFit ? "cover" : "contain"} alt={cardImage.title} />
    </div>
  ) : (
    ""
  );

  return (
    <div className="card">
      {image}
      {title || copy || buttonText || link ? (
        <div className="card--content">
          <div className="card--content__wrapper">
            {heading}
            {bodyCopy}
          </div>
          {button}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default IconAndImageCard;

export const query = graphql`
  fragment IconAndImageCard on ContentfulIconAndImageCard {
    cardImage {
      ...ImageFluid
    }
    title
    copy
    buttonText
    buttonType
    link
    objectFit
  }
`;
